import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import App from './App';
import authReducer from './store/reducers/auth';
import stationReducer from './store/reducers/station';
import createStationReducer from './store/reducers/createStation';
import stationDetailsReducer from './store/reducers/stationDetails';
import userReducer from './store/reducers/user';
import companyReducer from './store/reducers/company';
import companyDetailsReducer from './store/reducers/companyDetails';
import notificationReducer from './store/reducers/notification';

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}

const composeEnhancers =
  (window['__REDUX_DEVTOOLS_EXTENSION_COMPOSE__'] as typeof compose) || compose;
// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const reducers = combineReducers({
  auth: authReducer,
  station: stationReducer,
  createStation: createStationReducer,
  stationDetails: stationDetailsReducer,
  user: userReducer,
  company: companyReducer,
  companyDetails: companyDetailsReducer,
  notification: notificationReducer,
});

const store = createStore(reducers, composeEnhancers(applyMiddleware(thunk)));

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  // eslint-disable-next-line comma-dangle
  document.getElementById('root')
);
